﻿import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectPreLogin',
    name: 'IFPageOneHFortyFiveNoDownloadDirectPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFortyFiveNoDownloadDirectLogin' ||
        from.path === '/IFPageOneHFortyFiveNoDownloadDirectLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectLogin',
    name: 'pageOneHFortyFiveNoDownloadDirectLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/login.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectLoginLoading',
    name: 'pageOneHFortyFiveNoDownloadDirectLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectLeaveInfo',
    name: 'pageOneHFortyFiveNoDownloadDirectLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectResult',
    name: 'pageOneHFortyFiveNoDownloadDirectResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/result.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectLoading',
    name: 'pageOneHFortyFiveNoDownloadDirectLoading',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectLoginSecond',
    name: 'pageOneHFortyFiveNoDownloadDirectLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectOnline',
    name: 'pageOneHFortyFiveNoDownloadDirectOnline',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFortyFiveNoDownloadDirectLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectNoProducts',
    name: 'pageOneHFortyFiveNoDownloadDirectNoProducts',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/noProducts.vue'),
    meta: {
      title: projectName,
    },
  },
  /*{
    path: '/IFPageOneHFortyFiveNoDownloadDirectCar',
    name: 'pageOneHFortyFiveNoDownloadDirectCar',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectCarDetails',
    name: 'pageOneHFortyFiveNoDownloadDirectCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },*/
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectBlank',
    name: 'pageOneHFortyFiveNoDownloadDirectBlank',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectOnlineTab',
    name: 'pageOneHFortyFiveNoDownloadDirectOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadDirectOnlineAd',
    name: 'pageOneHFortyFiveNoDownloadDirectOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownloadDirect/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
